<template>
  <!-- 车辆列表 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.equipment.text5')">
          <el-select
            v-model="searchParams.belongBikeCategoryId"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="(item, index) in belongCategoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text6')">
          <el-select
            v-model="searchParams.belongBikeTypeId"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="(item, index) in belongBikeTypeList"
              :key="index"
              :label="item.bikeTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('pages.equipment.text8')">
          <el-input
            clearable
            v-model="searchParams.batchId"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text10')">
          <el-input
            clearable
            v-model="searchParams.ecuSn"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('omission.text55')">
          <el-select
            v-model="searchParams.hasOwner"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 车架号 -->
        <el-form-item :label="$t('pages.equipment.text86')">
          <el-input
            class="mac"
            type="textarea"
            :rows="3"
            v-model="searchParams.bikeFrameSn"
            :placeholder="$t('omission.text56')"
            oninput="value = value.replace(/[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s,.?!，。？!…—&$=()-+/*{}[\]]|\s/g, '')"
            maxlength="12999"
          >
          </el-input>
        </el-form-item>

        <!-- 车辆编码 -->
        <el-form-item :label="$t('pages.equipment.text7')">
          <el-input
            class="mac"
            type="textarea"
            :rows="3"
            v-model="searchParams.bikeCode"
            :placeholder="$t('omission.text56')"
            oninput="value = value.replace(/[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s,.?!，。？!…—&$=()-+/*{}[\]]|\s/g, '')"
            maxlength="12999"
          >
          </el-input>
        </el-form-item>

        <!-- mac地址 -->
        <el-form-item :label="$t('omission.text51')">
          <el-input
            class="mac"
            type="textarea"
            :rows="3"
            v-model="searchParams.bleMac"
            :placeholder="$t('omission.text56')"
            oninput="value = value.replace(/[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s,.?!，。？!…—&$=()-+/*{}[\]]|\s/g, '')"
            maxlength="12999"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('omission.text82')">
          <el-input
            clearable
            v-model="searchParams.saleAgent"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('omission.text83')">
          <el-select
            v-model="searchParams.isActivate"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="(item, index) in openList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('omission.text84')">
          <el-input
            clearable
            v-model="searchParams.logisticsOrder"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('omission.text85')">
          <el-input
            clearable
            v-model="searchParams.saleNo"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['equipmentList:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['equipmentList:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="custom"
        @click="equipmentImport"
        :title="$t('button.import')"
        icon="el-icon-upload2"
        v-permission="['equipmentList:import']"
      ></DiluButton>
      <DiluButton
        type="export"
        @click="equipmentExport"
        v-permission="['equipmentList:export']"
      ></DiluButton>
      <DiluButton
        type="custom"
        :title="$t('button.replaceModel')"
        @click="replace"
        v-permission="['equipmentList:replaceModel']"
      ></DiluButton>
      <DiluButton
        type="custom"
        :title="$t('button.replaceOther')"
        @click="openOther"
        v-permission="['equipmentList:replaceOther']"
      ></DiluButton>
      <DiluButton
        type="delete"
        v-permission="['equipmentList:remove']"
        @click="remove"
        v-if="selectIds.length > 0"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      @handleSelectionChange="handleSelectionChange"
      :total="total"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        prop="bikeCode"
        :label="$t('pages.equipment.text7')"
        width="130"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeCategoryName"
        :label="$t('pages.equipment.text5')"
        width="130"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeTypeName"
        :label="$t('pages.equipment.text6')"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="deviceCode"
        :label="$t('omission.text3')"
        width="210"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="batteryPower"
        :label="$t('pages.equipment.text12') + '(' + '%' + ')'"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="totalDistance"
        :label="$t('pages.equipment.text57') + '(' + 'km' + ')'"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.totalDistance ? scope.row.totalDistance : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bikeStatus"
        :label="$t('pages.equipment.text13')"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.bikeStatus == 0
              ? $t("pages.equipment.text14")
              : $t("pages.equipment.text15")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="communicationStatus"
        :label="$t('pages.equipment.text16')"
        width="170"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.communicationStatus == 1
              ? $t("pages.equipment.text17")
              : $t("pages.equipment.text18")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="appAccount"
        :label="$t('omission.text55')"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.appAccount ? scope.row.appAccount : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="batchId"
        :label="$t('pages.equipment.text20')"
        width="100"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="bikeFrameSn"
        :label="$t('pages.equipment.text86')"
        width="120"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="bleMac"
        :label="$t('omission.text51')"
        width="140"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        width="180"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="edit(scope.row)"
              type="text"
              v-permission="['equipmentList:see']"
              >{{ $t("button.edit") }}</el-button
            >
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['equipmentList:see']"
              >{{ $t("button.look") }}</el-button
            >
            <el-button
              v-permission="['equipmentList:unbound']"
              @click="unbound(scope.row)"
              type="text"
              :disabled="scope.row.appAccount ? false : true"
              >{{ $t("button.unbindUser") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 编辑弹窗 -->
    <EquipmentListEdit
      @editClose="editClose"
      :editVisible="editVisible"
      :belongCategoryList="belongCategoryList"
      :belongBikeTypeList="belongBikeTypeList"
      @equipmentList="equipmentList"
      :info="info"
    />

    <!-- 新增弹窗 -->
    <EquipmentImput
      @dialogClose="dialogClose"
      @equipmentList="equipmentList"
      :dialogVisible="dialogVisible"
      :belongCategoryList="belongCategoryList"
    />

    <!-- 更换型号 -->
    <ReplaceModel
      :replaceVisible="replaceVisible"
      @closeReplace="closeReplace"
      :findAllBatchList="findAllBatchList"
      :findAllBikeTypeList="findAllBikeTypeList"
      @equipmentList="equipmentList"
      :belongCategoryList="belongCategoryList"
    />

    <!-- 解绑用户 -->
    <UnboundModel
      :unboundVisible="unboundVisible"
      @closeUnbound="closeUnbound"
      :currentEquipment="currentEquipment"
      @equipmentList="equipmentList"
    />

    <!-- 更换其他信息 -->
    <OtherModel
      :otherVisible="otherVisible"
      @closeOther="closeOther"
      @equipmentList="equipmentList"
    />
    
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import EquipmentImput from "./module/equipmentImput.vue";
import ReplaceModel from "./module/replaceModel.vue";
import UnboundModel from "./module/unboundModel.vue";
import EquipmentListEdit from "./module/equipmentListEdit";
import OtherModel from "./module/otherModel.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      otherVisible: false, //更换其他信息
      currentEquipment: {},
      unboundVisible: false, //解绑用户
      selectIds: [],
      replaceVisible: false, //更换型号
      searchParams: {
        batchId: "", //批次号
        belongBikeTypeId: "", //车辆型号id
        belongBikeCategoryId: "", //车辆类别id
        bikeCode: "", //车辆编码
        hasOwner: "", //有无绑定车主
        ecuSn: "", //电控编码
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        bleMac: "", //mac地址
        bikeFrameSn: "", //车架号
        saleAgent: null, //经销商
        logisticsOrder: null, //货柜码
        saleNo: null, //销售单号
        isActivate: null,
      },
      info: {},
      editVisible: false,
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      openList: [
        {
          value: 0,
          label: "未激活",
        },
        {
          value: 1,
          label: "已激活",
        },
      ],
      options: [
        {
          value: 1,
          label: this.$t("omission.text53"),
        },
        {
          value: 2,
          label: this.$t("omission.text54"),
        },
      ],
      total: 0,
      tableData: [],
      belongCategoryList: [],
      belongBikeTypeList: [],
      findAllBatchList: [],
      findAllBikeTypeList: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    EquipmentImput,
    ReplaceModel,
    UnboundModel,
    OtherModel,
    EquipmentListEdit,
  },
  mounted() {
    this.equipmentList();
    this.bikeCategoryListAll();
    this.equipmentModeListAll();
    this.findAllBatchId();
    this.findAllBikeTypeName();
  },
  computed: {
    ...mapState(["platformData"]),
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.equipmentList();
    },
    //编辑
    edit(e) {
      this.info = e;
      this.editVisible = true;
    },
    //关闭编辑
    editClose() {
      this.editVisible = false;
    },
    //打开更换其他窗口
    openOther() {
      this.otherVisible = true;
    },
    //关闭更换其他窗口
    closeOther() {
      this.otherVisible = false;
    },
    //打开解绑弹窗
    unbound(e) {
      this.currentEquipment = e;
      this.unboundVisible = true;
    },
    //关闭解绑弹窗
    closeUnbound() {
      this.unboundVisible = false;
    },
    //车辆列表-根据批次号更新-批次ID下拉框
    findAllBatchId() {
      this.request.findAllBatchId().then((res) => {
        this.findAllBatchList = res.data;
      });
    },
    //车辆列表-根据批次号更新-新车辆型号下拉框
    findAllBikeTypeName() {
      this.request.findAllBikeTypeName().then((res) => {
        this.findAllBikeTypeList = res.data;
      });
    },
    //打开更换型号弹窗
    replace() {
      this.replaceVisible = true;
    },
    //关闭更换型号
    closeReplace() {
      this.replaceVisible = false;
    },
    //导出车辆列表
    equipmentExport() {
      let params = this.searchParams;
      params.belongCustomerId = this.platformData.id;
      this.request.equipmentListExportExcel(params).then(() => {});
    },
    //打开导入
    equipmentImport() {
      this.dialogVisible = true;
    },
    //关闭导入
    dialogClose() {
      this.dialogVisible = false;
    },
    //获取车辆列表
    equipmentList() {
      this.request.equipmentList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //选中触发
    handleSelectionChange(e) {
      this.selectIds = e.map((item) => {
        return item.id;
      });
    },
    //车辆类别-查询所有
    bikeCategoryListAll() {
      this.request.bikeCategoryListAll().then((res) => {
        this.belongCategoryList = res.data;
      });
    },
    //车辆型号-查询所有
    equipmentModeListAll() {
      this.request.equipmentModeListAll().then((res) => {
        this.belongBikeTypeList = res.data;
      });
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          hasOwner: "", //有无绑定车主
          batchId: "", //批次号
          belongBikeTypeId: "", //车辆型号id
          belongBikeCategoryId: "", //车辆类别id
          bikeCode: "", //车辆编码
          ecuSn: "", //电控编码
          pageNum: e, //页码
          pageSize: 10, //每页条数
        };
      }
      this.searchParams.pageNum = e;
      this.equipmentList();
    },
    //查看
    see(e) {
      this.$router.push({
        path: "/equipment/deviceManagement/equipmentInfo",
        query: {
          id: e.id,
          bikeCode: e.bikeCode,
        },
      });
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        batchId: "", //批次号
        belongBikeTypeId: "", //车辆型号id
        belongBikeCategoryId: "", //车辆类别id
        bikeCode: "", //车辆编码
        hasOwner: "", //有无绑定车主
        ecuSn: "", //电控编码
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        bleMac: "", //mac地址
        bikeFrameSn: "", //车架号
        saleAgent: null, //经销商
        logisticsOrder: null, //货柜码
        saleNo: null, //销售单号
        isActivate: null,
      };
      this.total = 0;
      this.equipmentList();
    },
    //批量删除
    remove() {
      this.$confirm(this.$t("omission.text38"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          let removeParams = {
            ids: this.selectIds,
            appCode: this.platformData.appCode,
          };
          this.request.equipmentListDelete(removeParams).then(() => {
            this.$message({
              type: "success",
              message: this.$t("public.text7"),
            });
            this.total = 0;
            this.searchParams.pageNum = 1;
            this.equipmentList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.mac {
  width: 380px;
}
</style>